import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getConfig = () => axios.get(`${API}/config`).then((r) => r.data);
export const getAvailability = (date) =>
    axios.get(`${API}/availability`, { params: { date } }).then((r) => r.data);
export const createBooking = (data) => axios.post(`${API}/bookings`, data).then((r) => r.data);
export const getTestimonials = () => axios.get(`${API}/testimonials`).then((r) => r.data);
export const sendContact = (data) => axios.post(`${API}/contact`, data).then((r) => r.data);
export const createCheckout = (data) =>
    axios.post(`${API}/payments/checkout`, data).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
    axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);

const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const adminLogin = (password) =>
    axios.post(`${API}/admin/login`, { password }).then((r) => r.data);
export const adminBookings = (t) => axios.get(`${API}/admin/bookings`, auth(t)).then((r) => r.data);
export const adminCreateBooking = (t, data) =>
    axios.post(`${API}/admin/bookings`, data, auth(t)).then((r) => r.data);
export const adminCancelBooking = (t, id) =>
    axios.delete(`${API}/admin/bookings/${id}`, auth(t)).then((r) => r.data);
export const adminBlocks = (t) => axios.get(`${API}/admin/blocks`, auth(t)).then((r) => r.data);
export const adminAddBlock = (t, data) =>
    axios.post(`${API}/admin/blocks`, data, auth(t)).then((r) => r.data);
export const adminDeleteBlock = (t, id) =>
    axios.delete(`${API}/admin/blocks/${id}`, auth(t)).then((r) => r.data);
export const adminAvailability = (t) =>
    axios.get(`${API}/admin/availability`, auth(t)).then((r) => r.data);
export const adminSaveSchedule = (t, days) =>
    axios.put(`${API}/admin/availability/schedule`, { days }, auth(t)).then((r) => r.data);
export const adminAddOpening = (t, data) =>
    axios.post(`${API}/admin/openings`, data, auth(t)).then((r) => r.data);
export const adminDeleteOpening = (t, id) =>
    axios.delete(`${API}/admin/openings/${id}`, auth(t)).then((r) => r.data);
export const getBooking = (id) => axios.get(`${API}/bookings/${id}`).then((r) => r.data);
export const cancelBookingPublic = (id, origin) =>
    axios.post(`${API}/bookings/${id}/cancel`, { origin_url: origin }).then((r) => r.data);
export const adminNoShow = (t, id) =>
    axios.post(`${API}/admin/bookings/${id}/no-show`, {}, auth(t)).then((r) => r.data);
export const adminGoogleStatus = (t) =>
    axios.get(`${API}/admin/google/status`, auth(t)).then((r) => r.data);
export const adminGoogleConnect = (t) =>
    axios.get(`${API}/admin/google/connect`, auth(t)).then((r) => r.data);
export const adminGoogleDisconnect = (t) =>
    axios.post(`${API}/admin/google/disconnect`, {}, auth(t)).then((r) => r.data);

export const adminProposals = (t) => axios.get(`${API}/admin/proposals`, auth(t)).then((r) => r.data);
export const adminCreateProposal = (t, d) =>
    axios.post(`${API}/admin/proposals`, d, auth(t)).then((r) => r.data);
export const adminSendProposal = (t, id) =>
    axios.post(`${API}/admin/proposals/${id}/send`, {}, auth(t)).then((r) => r.data);
export const adminDeleteProposal = (t, id) =>
    axios.delete(`${API}/admin/proposals/${id}`, auth(t)).then((r) => r.data);
export const adminLinkProposal = (t, id, clientId) =>
    axios.post(`${API}/admin/proposals/${id}/link`, { client_id: clientId }, auth(t)).then((r) => r.data);
export const adminProposalPdf = async (t, id, title) => {
    const r = await axios.get(`${API}/admin/proposals/${id}/pdf`, { ...auth(t), responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `consulting-worx-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
};

export const adminInvoices = (t) => axios.get(`${API}/admin/invoices`, auth(t)).then((r) => r.data);
export const adminCreateInvoice = (t, d) =>
    axios.post(`${API}/admin/invoices`, d, auth(t)).then((r) => r.data);
export const adminSendInvoice = (t, id) =>
    axios.post(`${API}/admin/invoices/${id}/send`, {}, auth(t)).then((r) => r.data);
export const adminInvoicePayLink = (t, id) =>
    axios.post(`${API}/admin/invoices/${id}/pay-link`, {}, auth(t)).then((r) => r.data);
export const adminMarkInvoicePaid = (t, id) =>
    axios.post(`${API}/admin/invoices/${id}/paid`, {}, auth(t)).then((r) => r.data);
export const adminDeleteInvoice = (t, id) =>
    axios.delete(`${API}/admin/invoices/${id}`, auth(t)).then((r) => r.data);
export const adminLinkInvoice = (t, id, clientId) =>
    axios.post(`${API}/admin/invoices/${id}/link`, { client_id: clientId }, auth(t)).then((r) => r.data);

export const adminClients = (t) => axios.get(`${API}/admin/clients`, auth(t)).then((r) => r.data);
export const adminCreateClient = (t, d) =>
    axios.post(`${API}/admin/clients`, d, auth(t)).then((r) => r.data);
export const adminUpdateClient = (t, id, d) =>
    axios.put(`${API}/admin/clients/${id}`, d, auth(t)).then((r) => r.data);
export const adminDeleteClient = (t, id) =>
    axios.delete(`${API}/admin/clients/${id}`, auth(t)).then((r) => r.data);
export const adminSendClientEmail = (t, d) =>
    axios.post(`${API}/admin/clients/email`, d, auth(t)).then((r) => r.data);
